import {AuthAction} from 'shared/constants/AppConst';

export const isPermit = (ability, authorities = []) => {
  return (
    authorities?.length === 0 ||
    (authorities?.length > 0 &&
      authorities.some((authority) =>
        ability.can(authority.action || AuthAction.view, authority.subject),
      ))
  );
};
